import { observer } from 'mobx-react-lite';
import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { buildMarketDataKeys } from '../../../../../../../stores/websocketStore/utils/marketDataRouting';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { Body2, Body3 } from '../../../../../../atomic/text/Text';

type Props = {
  symbol: string;
  dataSource: string;
  brokerage?: string;
};

export const BidAskComponent = observer(({ symbol, dataSource, brokerage }: Props) => {
  const { priceDataStore } = useWebsocketStore();
  const hash = buildMarketDataKeys({ symbol, dataSource, brokerage }).find(
    (key) => priceDataStore.lastQuote[key]
  );
  const { bid, ask } = (hash && priceDataStore.lastQuote[hash]) ?? { bid: 0, ask: 0 };
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          Bid:
        </Body3>
        <Body3 color={colors.lightGrey} fontWeight={500} margin="0 0 0 0">
          ${ApplyRounding(bid, 2)}
        </Body3>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          Ask:
        </Body3>
        <Body3 color={colors.lightGrey} fontWeight={500} margin="0 0 0 0">
          ${ApplyRounding(ask, 2)}
        </Body3>
      </div>
    </div>
  );
});
